import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/pelletizing/QualityData";
import {
    newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.QualityData(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
        qualityPlanStatus: '',
        itemCode:[]
    }) //TODO load at the application start
    .withActions({
        qualityPlanStatus(context, entity) {

            context.state.qualityPlanStatus = entity;

        },
        selectItem(context) {
            context.dispatch("api/get", {
            url: process.env.VUE_APP_MASTER_API_URL + "production-service/prd" + "/qualityItem/findAll"
                }, 
                { root: true })
                .then(function(data) {
                    context.commit("setItemCode", data);
                })
        },
        jumpToQualityCheck(context, entity) {
                           
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/qualityData/findByReview/" + entity.id
            },{ root: true })
            .then(response => {
                //seting the values
                {
                       
                    context.commit('qualityData' + "/setRows", [response], { root: true });   
                    router.push("/prd/qualityCheck");   
                                              
                }       
            });       
        },

        Receive(context, entity) { //绑定质量计划的方法
            context.state.entity.planId = context.state.qualityPlanStatus.id;

            context.dispatch("api/post", {
                url: context.state.baseModuleUrl + "/" + entity + "/receive",
                data: context.state.entity,

            }, {
                root: true
            })
                .then(function () {
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Sucess!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, {
                        root: true
                    }).then(function () {
                        context.dispatch("api/get", {
                            url: context.state.baseModuleUrl + "/qualityPlan" + "/findById/" + context.state.entity.planId
                        }, {
                            root: true
                        })
                            .then(response => {
                                {
                                    context.commit('qualityData' + "/setRows", response.qualityDatas, {
                                        root: true
                                    });

                                }
                            });
                    })
                });
        },
        ReceiveSample(context, entity) { //单独页面的方法
            context.state.entity.planId = context.state.qualityPlanStatus.id;

            return context.dispatch("api/post", {
                url: context.state.baseModuleUrl + "/" + entity + "/receive",
                data: context.state.entity,

            }, {
                root: true
            })
                .then(function () {
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Sucess!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, {
                        root: true
                    })
                });
        },
        Details(context, entity) {

            if (entity.status == 'N') {
                context.dispatch("base/showWarning", {
                    userAlertWarningStr: 'lbl.qualityData.status.NotReceive',
                    userAlertWarningVisible: true,
                }, {
                    root: true
                });
            } else {
                router.push({
                    path: '/prd/qualityDataCheck',
                    query: {
                        id: entity.id,
                    }
                });
                context.dispatch("qualityResult/qualityDataStatus", entity, {
                    root: true
                });
            }
        },
    })
    .withMutations({
        setItemCode(state,data){
            state.itemCode = data
        }
    })
    .buildStore()